'use client';



import { useNavigate } from "../../hooks/useNavigate";
import React, { useEffect } from "react";

import SectionType1 from "../../components/Sections/SectionType1";
import SecondaryTag from "../../components/Tags/SecondaryTag";

import {

  FaRProject,
  FaUsers,
  FaDatabase,
  FaBuilding,
  FaMusic,
  FaPodcast,
  FaQrcode,
  FaSuitcase,
  FaNetworkWired,
  FaScaleBalanced,
  FaCalendar,
  FaToolbox,
  FaFileContract,
  FaHotel,
  FaUniversalAccess,
  FaMoneyBillWave,
  FaMobile,
  FaUsersGear,
  FaPencil,
  FaChartLine,
  FaSearchengin,
  FaFilePdf,
  FaAddressBook,
  FaGroupArrowsRotate,
  FaMoneyBill,
  FaBoxArchive,
  FaAutoprefixer,
} from "react-icons/fa6";

const clickMyPhoto = "/assets/additional_services/click-my-photo.png";
const ipdjm = "/assets/additional_services/ipdjm.png";
const pdf = "/assets/additional_services/pdf.png";
const music = "/assets/additional_services/music.png";
const qr = "/assets/additional_services/qr.png";
const travel = "/assets/additional_services/travel.png";
const blockChain = "/assets/additional_services/block-chain.png";
const fitTrack = "/assets/additional_services/fit-track.png";
const teamWork = "/assets/additional_services/team-work.png";
const connect = "/assets/additional_services/connect.png";
const news = "/assets/additional_services/news.png";
const build = "/assets/additional_services/build.png";
const fundTrack = "/assets/additional_services/fund-track.png";
const talent = "/assets/additional_services/talent.png";
const crm = "/assets/additional_services/build.png";
const file = "/assets/additional_services/file.png";
const customErp = "/assets/additional_services/custom-erp.png";
const erp = "/assets/additional_services/fund-track.png";

const services = [
  {
    id: 1,
    image: build,
    urlImage: "centera_buildpro.png",
    title: "Centera BuildPro",
    description: "Construction Management Software",
    tags: [
      { text: "Project Tools", icon: FaRProject },
      { text: "Asset Tracker", icon: FaBuilding },
      { text: "3D Viewer", icon: FaToolbox },
      { text: "Civil Tools", icon: FaScaleBalanced },
    ],
  },
  {
    id: 2,
    image: ipdjm,
    urlImage: "ipartydjmix.png",
    title: "iPartyDJMix",
    description: "Event Management Software",
    tags: [
      { text: "Client Booking", icon: FaUsersGear },
      { text: "Event Tools", icon: FaMusic },
      { text: "Profile Tools", icon: FaDatabase },
      { text: "Party Planner", icon: FaToolbox },
    ],
  },
  {
    id: 3,
    image: clickMyPhoto,
    urlImage: "click_my_photo.png",
    title: "Click My Photo",
    description: "Photography Management Platform",
    tags: [
      { text: "Photo Albums", icon: FaFileContract },
      { text: "Client Choice", icon: FaToolbox },
      { text: "Events", icon: FaCalendar },
      { text: "Photo Tools", icon: FaBuilding },
    ],
  },
  {
    id: 4,
    image: pdf,
    urlImage: "centera_flipviewer.png",
    title: "Centera FlipViewer",
    description: "PDF Flipbook Viewer",
    tags: [
      { text: "PDF Viewer", icon: FaFilePdf },
      { text: "Page Flip", icon: FaToolbox },
      { text: "E-Books", icon: FaMobile },
      { text: "Interactive UI", icon: FaPencil },
    ],
  },
  {
    id: 5,
    image: fundTrack,
    urlImage: "centera_fundtrack.png",
    title: "Centera FundTrack",
    description: "Trading and Investment Platforms",
    tags: [
      { text: "Invest Monitor", icon: FaMoneyBillWave },
      { text: "Fund Manage", icon: FaUniversalAccess },
      { text: "Trading Tools", icon: FaNetworkWired },
      { text: "Analytics", icon: FaDatabase },
    ],
  },
  {
    id: 6,
    image: connect,
    urlImage: "centera_connect.png",
    title: "Centera Connect",
    description: "Social Media Platform",
    tags: [
      { text: "User Profiles", icon: FaUsersGear },
      { text: "Business Tools", icon: FaBuilding },
      { text: "Social Links", icon: FaNetworkWired },
      { text: "Connectivity", icon: FaToolbox },
    ],
  },
  {
    id: 7,
    image: news,
    urlImage: "centera_news.png",
    title: "Centera News",
    description: "News Portal",
    tags: [
      { text: "News Feed", icon: FaFileContract },
      { text: "Live Updates", icon: FaPencil },
      { text: "Responsive UI", icon: FaMobile },
      { text: "Content Tools", icon: FaNetworkWired },
    ],
  },
  {
    id: 8,
    image: music,
    urlImage: "centera_musicwave.png",
    title: "MusicWave & PodCastify",
    description: "Podcast & Music Streaming Platforms",
    tags: [
      { text: "Music Stream", icon: FaMusic },
      { text: "Podcast Host", icon: FaPodcast },
      { text: "Discovery", icon: FaToolbox },
      { text: "Audio Tools", icon: FaDatabase },
    ],
  },
  {
    id: 9,
    image: qr,
    urlImage: "centera_qrpro.png",
    title: "Centera QRPro",
    description: "QR Code Generator and Scanner",
    tags: [
      { text: "Custom QR", icon: FaQrcode },
      { text: "Analytics", icon: FaDatabase },
      { text: "Branding", icon: FaPencil },
      { text: "Scanner", icon: FaBuilding },
    ],
  },
  {
    id: 10,
    image: blockChain,
    urlImage: "centera_blockchainx.png",
    title: "Centera BlockChainX",
    description: "Blockchain Solutions",
    tags: [
      { text: "Blockchain", icon: FaUniversalAccess },
      { text: "Smart Contracts", icon: FaScaleBalanced },
      { text: "Data Manage", icon: FaDatabase },
      { text: "Transactions", icon: FaMoneyBillWave },
    ],
  },
  {
    id: 11,
    image: travel,
    urlImage: "centera_travelease.png",
    title: "Centera TravelEase",
    description: "Secure Travel Booking Management",
    tags: [
      { text: "Bookings", icon: FaSuitcase },
      { text: "Travel Tools", icon: FaHotel },
      { text: "Itinerary", icon: FaToolbox },
      { text: "Secure UI", icon: FaBuilding },
    ],
  },
  {
    id: 12,
    image: fitTrack,
    urlImage: "centera_fittrack.png",
    title: "Centera FitTrack",
    description: "Health and Fitness Monitor System",
    tags: [
      { text: "Health Data", icon: FaToolbox },
      { text: "Fitness Plan", icon: FaUsers },
      { text: "Wearables", icon: FaToolbox },
      { text: "Metrics", icon: FaDatabase },
    ],
  },
  {
    id: 13,
    image: talent,
    urlImage: "centera_talentbook.png",
    title: "Centera TalentBook",
    description: "Fashion Show Talent Booking System",
    tags: [
      { text: "Talent Hire", icon: FaUsersGear },
      { text: "Payment Tools", icon: FaMoneyBillWave },
      { text: "Schedules", icon: FaBuilding },
      { text: "Fashion Tools", icon: FaPencil },
    ],
  },
  {
    id: 14,
    image: file,
    urlImage: "centera_filemaster.png",
    title: "Centera FileMaster",
    description: "File Manager",
    tags: [
      { text: "File Manage", icon: FaFileContract },
      { text: "Cloud Sync", icon: FaDatabase },
      { text: "File Sharing", icon: FaNetworkWired },
      { text: "Advanced Search", icon: FaSearchengin },
    ],
  },
  {
    id: 15,
    image: teamWork,
    urlImage: "centera_teamwork.png",
    title: "Centera Teamwork",
    description: "Team Collaboration Tools",
    tags: [
      { text: "Tracking", icon: FaRProject },
      { text: "Team Chat", icon: FaNetworkWired },
      { text: "Collab Tools", icon: FaUsers },
      { text: "Workflows", icon: FaToolbox },
    ],
  },
  {
    id: 16,
    image: crm,
    urlImage: "centera_crmpro.png",
    title: "Centera CRMPro",
    description: "Customer Relationship Management (CRM)",
    tags: [
      { text: "Lead Manage", icon: FaAddressBook },
      { text: "Sales Tools", icon: FaScaleBalanced },
      { text: "Marketing", icon: FaGroupArrowsRotate },
      { text: "CRM Tools", icon: FaToolbox },
    ],
  },
  {
    id: 17,
    image: erp,
    urlImage: "centera_erpworks.png",
    title: "Centera ERPWorks",
    description: "Enterprise Resource Planning (ERP)",
    tags: [
      { text: "Finance", icon: FaMoneyBill },
      { text: "HR Tools", icon: FaBoxArchive },
      { text: "Analytics", icon: FaScaleBalanced },
      { text: "ERP Tools", icon: FaToolbox },
    ],
  },
  {
    id: 18,
    image: customErp,
    urlImage: "custom_enterprise_solutions.png",
    title: "Tailored Solutions",
    description: "Custom Enterprise Solutions",
    tags: [
      { text: "Custom ERP", icon: FaBuilding },
      { text: "HR Manage", icon: FaScaleBalanced },
      { text: "Workflows", icon: FaNetworkWired },
      { text: "Automation", icon: FaAutoprefixer },
    ],
  },
];

function AdditionalServices() {
  return (
    <div className="relative 2xl:mx-5">
      <div className="absolute inset-0 pointer-events-none z-30">
        <div className="mt-2 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="-mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="mt-2 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="-mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="mt-2 2xl:hidden bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="-mt-40 2xl:hidden bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="-mt-40 2xl:hidden bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
      </div>

      <div className="flex flex-col items-center justify-center mt-10 w-[240px] md:w-full mx-auto">
        <SecondaryTag text={"Additional Services"} />
        <h1 className=" text-color-1 text-center text-4xl lg:text-6xl font-medium leading-[normal] my-10 mb-16">
          Advanced Software Solutions
        </h1>
      </div>

      <SectionType1>
        <InServices />
      </SectionType1>

      {/* <div className="bg-color-50 h-32 w-32 fixed right-0 bottom-0 z-50"></div> */}
    </div>
  );
}

export default AdditionalServices;

const InServices = () => {
  const navigate = useNavigate();

  const handleItemClick = (serviceId) => {
    navigate(`/contact-us`, { state: { service: 3 } });
  };

  return (
    <div className=" max-w-[1340px] 2xl:max-w-[1700px] mx-auto relative">
      <div className="flex flex-row flex-wrap xl:flex-col 2xl:flex-row justify-around gap-8 mx-4 md:mx-16 ">
        {services.map((service, index) => (
          <div
            key={index}
            className={`w-full md:w-[45%] lg:w-full 2xl:w-[48%] flex flex-col lg:flex-row items-center ${
              index % 2 === 0 ? "" : "lg:flex-row-reverse"
            }`}
          >
            <div
              className="w-full"
              //   className={`flex ${
              //     !(index % 4 === 2 || index % 4 === 3)
              //       ? "justify-start"
              //       : "justify-end"
              //   }`}
            >
              <div
                className="w-full"
                onClick={() => handleItemClick(service.id)}
              >
                <ServiceCard
                  // rev={index % 2 === 0}
                  rev={
                    window.innerWidth >= 1536
                      ? index % 4 === 2 || index % 4 === 3
                      : index % 2 === 0
                  }
                  title={service.title}
                  description={service.description}
                  tags={service.tags}
                  image={service.image}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Tag = ({ text, Icon }) => (
  <div className="flex items-center gap-2.5 py-2 px-2 md:px-4 rounded-lg border-[0.771px] border-color-97 bg-color-99 group transition-all duration-300">
    <Icon className="w-4 h-4 text-[#cfd3da] group-hover:text-[var(--accent-light)] transition-all duration-300" />
    <div className="text-[#cfd3da] text-xs leading-[normal] transition-all duration-300 whitespace-nowrap">
      {text}
    </div>
  </div>
);

const ServiceCard = ({ rev, title, description, tags, image }) => {
  const [isLargeScreen, setIsLargeScreen] = React.useState(
    window.innerWidth >= 1024
  );

  React.useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="relative h-full p-px rounded-xl w-full overflow-hidden cursor-pointer group">
      <div
        className={`absolute inset-0 rounded-xl bg-[linear-gradient(155deg,var(--accent-light),var(--secondary-bg)_80%)] transition-transform duration-700 group-hover:rotate-180 blur-3xl scale-150`}
      ></div>
      <div
        className={`lg:h-52 2xl:h-[210px] flex flex-col lg:flex-row overflow-hidden ${
          !rev ? "lg:flex-row-reverse" : ""
        } items-center lg:items-stretch gap-0 lg:gap-6 rounded-xl bg-[var(--secondary-bg)] backdrop-blur-[7px] shadow-lg`}
      >
        {/* Image Section */}
        <div
          className="w-full lg:w-[40%] h-40 lg:h-full scale-125 md:scale-150 lg:scale-125 group-hover:scale-110 transition-all duration-700"
          style={
            isLargeScreen
              ? {
                  clipPath: !rev
                    ? "polygon(0 0, 100% 0, 100% 100%, 20% 100%)"
                    : "polygon(0 0, 80% 0, 100% 100%, 0% 100%)",
                }
              : {
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 70%)",
                }
          }
        >
          <img
            loading="lazy"
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-125 transition-all duration-700 md:grayscale-[70%] md:opacity-80 group-hover:opacity-100 group-hover:grayscale-[0%]"
          />
        </div>

        {/* Content Section */}
        <div className="w-full lg:w-[75%] relative flex flex-col justify-center p-3 md:p-6 ">
          <div className="z-10 flex flex-col items-start gap-3">
            <div className="text-color-1 text-xl font-semibold md:font-bold">
              {title}
            </div>
            <div className="text-color-2">{description}</div>
          </div>
          <div className="flex flex-col lg:items-end gap-4 mt-4">
            <div className="grid grid-cols-2 md:grid-cols-1 lg:grid-cols-4 2xl:grid-cols-2 gap-2 gap-y-3 md:gap-4 px-2 lg:px-4 2xl:px-8">
              {tags.map((tag, index) => (
                <div className="flex justify-center" key={index}>
                  <Tag text={tag.text} Icon={tag.icon} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div
          className={`absolute top-5 ${
            rev ? "right-5" : "left-5"
          } -rotate-45 w-[300px] h-[100px] bg-[radial-gradient(circle,_var(--accent-dark),_var(--accent-dark))] blur-3xl opacity-30`}
        ></div>
      </div>
    </div>
  );
};
